export default __webpack_public_path__ + "static/media/earn-money.c0cc27e8.svg";